/**
 * Mobile-safe storage utility
 * 
 * Mobile Safari and some browsers clear sessionStorage during OAuth redirects.
 * This utility uses localStorage with expiry as a fallback for critical auth data.
 */

const AUTH_REDIRECT_KEY = 'chekdeal_auth_redirect';
const AUTH_REDIRECT_EXPIRY_KEY = 'chekdeal_auth_redirect_expiry';
const REDIRECT_EXPIRY_MS = 5 * 60 * 1000; // 5 minutes

/**
 * Store the redirect URL before OAuth
 * Uses both sessionStorage and localStorage for maximum compatibility
 */
export const setAuthRedirect = (url) => {
  try {
    // Try sessionStorage first (preferred for security)
    sessionStorage.setItem('auth_redirect', url);
  } catch (e) {
    console.warn('sessionStorage not available:', e);
  }
  
  try {
    // Also store in localStorage with expiry (fallback for mobile)
    localStorage.setItem(AUTH_REDIRECT_KEY, url);
    localStorage.setItem(AUTH_REDIRECT_EXPIRY_KEY, (Date.now() + REDIRECT_EXPIRY_MS).toString());
  } catch (e) {
    console.warn('localStorage not available:', e);
  }
};

/**
 * Get the redirect URL after OAuth callback
 * Tries sessionStorage first, falls back to localStorage
 */
export const getAuthRedirect = () => {
  let redirectUrl = null;
  
  // Try sessionStorage first
  try {
    redirectUrl = sessionStorage.getItem('auth_redirect');
    if (redirectUrl) {
      sessionStorage.removeItem('auth_redirect');
    }
  } catch (e) {
    console.warn('sessionStorage read failed:', e);
  }
  
  // If not found, try localStorage
  if (!redirectUrl) {
    try {
      const expiry = localStorage.getItem(AUTH_REDIRECT_EXPIRY_KEY);
      if (expiry && Date.now() < parseInt(expiry, 10)) {
        redirectUrl = localStorage.getItem(AUTH_REDIRECT_KEY);
      }
      // Always clean up localStorage
      localStorage.removeItem(AUTH_REDIRECT_KEY);
      localStorage.removeItem(AUTH_REDIRECT_EXPIRY_KEY);
    } catch (e) {
      console.warn('localStorage read failed:', e);
    }
  }
  
  return redirectUrl;
};

/**
 * Clear any stored auth redirect
 */
export const clearAuthRedirect = () => {
  try {
    sessionStorage.removeItem('auth_redirect');
  } catch (e) {}
  try {
    localStorage.removeItem(AUTH_REDIRECT_KEY);
    localStorage.removeItem(AUTH_REDIRECT_EXPIRY_KEY);
  } catch (e) {}
};
